import authenticatedAxios from "../services/authenticatedAxios";

// Approve request
export const approveOnboarding = async (dealers) => {
  try {
    const response = await authenticatedAxios.put(`/api/v1/dealerShipDetails/dealer/confirmOnBoarding/`, dealers, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data; // List<ActivationResponse>
  } catch (error) {
    console.error("Error approving dealer:", error);
    throw error;
  }
};

// Deny request
export const denyOnboarding = async (dealers) => {
  try {
    const response = await authenticatedAxios.put(`/api/v1/dealerShipDetails/dealer/denyOnBoarding/`, dealers, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data; // List<ActivationResponse>
  } catch (error) {
    console.error("Error denying dealer:", error);
    throw error;
  }
};
